/**
 * catchしたエラーを渡して、エラーメッセージを得る
 */

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const pickErrorMessages = (error: any): Array<string> => {
  if (!error) {
    return ['エラーが発生しました'];
  }

  // APIエラー
  if (error.errors && error.errors.length !== 0) {
    return Object.entries(error.errors).flatMap((obj) => {
      return obj.at(1);
    }) as Array<string>;
  }

  return [error.message];
};

/**
 * ページ遷移
 */
export const locationHref = (url: string, newTab: boolean) => {
  if (newTab) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    (window as any).open('about:blank', '_blank').location.href = url;
  } else {
    location.href = url;
  }
};

/**
 * ページ最上部へ瞬時にスクロールする
 *
 * ページ全体のスクロールコンテナはブラウザーによって異なるため、4経路すべてを指定する。
 * 本リポジトリは reset.scss で body に overflow: scroll を敷いており body 側も対象になり得る。
 *
 * なめらかなスクロール（behavior: 'smooth'）は受け付けない。scrollTop への代入（3・4番目）は
 * 常に瞬時スクロールになるため、引数で受け取っても最後の代入で打ち消され意味を持たないため。
 * なめらかに動かしたい用途が出た場合は、代入を使わない別の関数として用意する。
 */
export const scrollToPageTop = () => {
  if (typeof window === 'undefined') return;

  document.scrollingElement?.scrollTo({ top: 0, behavior: 'auto' });
  window.scrollTo({ top: 0, behavior: 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

/**
 * 任意の要素までスクロール
 */
export const scrollIntoTheView = (id: string) => {
  const element = document.getElementById(id) as HTMLElement;
  if (!element) return;

  const position = element.getBoundingClientRect();
  window.scrollTo({
    left: 0,
    top: position.top + window.scrollY - 100, //ヘッダー分ずらす
    behavior: 'smooth',
  });
};

/** 未ログインを表すHTTPステータスコード */
const HTTP_STATUS_UNAUTHORIZED = 401;

/**
 * 未ログインによるAPIエラーかどうかを判定する。
 *
 * バックエンドは未認証・退会・ユーザーステータス変更のいずれの場合も HTTP 401 を返す。
 * レスポンスボディの code は汎用エラーの 1 で、HTTP 404 / 400 / 500 と共通のため判定には使えない。
 *
 * 前提: 呼び出し側アプリの http() が、reject する値に HTTP ステータスを `status` として
 * 付与していること。付与していないアプリでは常に false を返すため、利用前に確認する。
 * 現時点で付与しているのは apps/raffle のみ（例: `Promise.reject({ ...responseJson, status: res.status })`）。
 * 他アプリはレスポンスボディだけを reject するため対象外。
 */
export const isUnauthorizedError = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && (error as { status?: number }).status === HTTP_STATUS_UNAUTHORIZED;
